import React from 'react'
import useAccount from '../../hooks/useAccount'
import useRouter from '../../hooks/useRouter'
import useCustomerTrackers from '../../hooks/useCustomerTrackers'
import { useAiAccess } from '../../hooks/useAiAccess'
import AdminDrawer from '../../pages/admin/AdminDrawer'

interface AdminNavDrawerProps {
  open: boolean
  onClose: () => void
}

/**
 * The admin menu as a right-hand slide-out, opened by the top bar's Admin
 * button on every page (Matt + Kai, 30 Sep 2026) — the place the old
 * three-dots pane used. It is the SAME list the admin pages show
 * (AdminDrawer's NAV_GROUPS), so there is one admin menu, not two.
 */
const AdminNavDrawer: React.FC<AdminNavDrawerProps> = ({ open, onClose }) => {
  const account = useAccount()
  const router = useRouter()
  const customer = account.customer?.name || ''
  const job = account.job?.name || ''
  const isManager = account.user?.role_permissions.isManager ?? false
  const isRealmAdmin = account.user?.role_permissions.isRealmAdmin ?? false
  const aiAccess = useAiAccess(customer)
  const isTeamManager = aiAccess.manages.length > 0
  // The customer's programme trackers, one Management item each (T12).
  const { trackers } = useCustomerTrackers(customer)

  return (
    <AdminDrawer
      anchor="right"
      variant="temporary"
      open={open}
      onClose={onClose}
      currentRoute={router.name || ''}
      currentParams={router.params as Record<string, string>}
      onNavigate={(route, params) => router.navigate(route, params)}
      customer={customer}
      job={job}
      trackers={trackers}
      isManager={isManager}
      isRealmAdmin={isRealmAdmin}
      isTeamManager={isTeamManager}
      isStatsReviewer={aiAccess.statsReviewer}
      isGuideReviewer={aiAccess.guideReviewer}
    />
  )
}

export default AdminNavDrawer
